import { useMemo } from 'react'
import { getCountries } from '@/lib/countries'
import { Combobox } from './combobox'

export function CountryCombobox(props: {
  value: string | null | undefined
  onChange: (value: string | null) => void
  id?: string
  disabled?: boolean
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}) {
  const options = useMemo(
    () =>
      getCountries().map((c) => ({
        value: c.code,
        label: c.name,
        hint: c.code,
        prefix: <span aria-hidden>{c.flag}</span>,
        keywords: [c.code],
      })),
    [],
  )
  return <Combobox {...props} options={options} allowClear placeholder="Select a country" searchPlaceholder="Search countries…" emptyText="No country found" />
}
